import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogDescription,
        DialogBody,
    } from '@/components/ui/dialog';
    import { computed, watch } from 'vue';
    import { toast } from 'vue-sonner';
    import { useForm, usePage } from '@inertiajs/vue3';
    import { useI18n } from 'vue-i18n';
    import { useQueryClient } from '@tanstack/vue-query';
    import { useVoucherStore } from '@/stores/voucher';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData, Voucher } from '@/types';
    import type { Table } from '@tanstack/vue-table';
    import VoucherAssignAssignedForm from '@/components/vouchers/VoucherAssignAssignedForm.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BulkAssignAssignedVouchersDialog',
  props: {
    table: {}
  },
  setup(__props: any) {

    const props = __props;

    const voucherStore = useVoucherStore();
    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    const { t } = useI18n();
    const queryClient = useQueryClient();

    const form = useForm({
        ids: [] as number[],
        assignee_ids: [] as string[],
        employee_ids: [] as number[],
        user_ids: [] as number[],
    });

    const handleUpload = () => {
        form.post(route('v2.voucher.admin.assign.selection'), {
            preserveScroll: true,
            onSuccess: () => {
                form.resetAndClearErrors();
                toast.success(t('vouchers.select.assign_confirm.success'));
                props.table.resetRowSelection();
                queryClient.invalidateQueries({ queryKey: [QueryKey.VOUCHERS, companyId] });
                voucherStore.toggleOpen('assigned', false);
            },
            onError: (error: any) => {
                if (error instanceof Error) {
                    toast.error(t('vouchers.select.assign_confirm.error'));
                }
            },
        });
    };

    watch(
        () => voucherStore.validVoucherIds,
        (newIds) => {
            form.ids = newIds;
        },
        { immediate: true },
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: _unref(voucherStore).assignedModalOpen,
    "onUpdate:open": _cache[1] || (_cache[1] = (value) => _unref(voucherStore).toggleOpen('assigned', value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _withModifiers(handleUpload, ["prevent"]),
            class: "flex max-h-full flex-col overflow-hidden"
          }, [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), { tabindex: "0" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('vouchers.select.assign_confirm.title')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogDescription), { class: "flex flex-col gap-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('vouchers.select.assign_confirm.content', {
                                amount: _unref(voucherStore).validVoucherIds.length,
                            })), 1)
                  ]),
                  _: 1
                }),
                _createVNode(VoucherAssignAssignedForm, {
                  form: _unref(form),
                  "company-id": companyId.value
                }, null, 8, ["form", "company-id"])
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogClose), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      size: "sm",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(form).resetAndClearErrors()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('forms.cancel')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: _unref(form).processing,
                  loading: _unref(form).processing,
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('forms.save')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})